import axios from 'axios';
import { URL_GET_FORM } from '../../utils/variables';

const getTelepayForm = (form_id) => axios.post(URL_GET_FORM, { form_id })
  .then(({ data }) => data.response)
  .catch(() => Promise.reject(new Error('Данный терминал не является сервисом')));

export default getTelepayForm;
